<template>
    <div>
        <div class="header-mobile">
            <a class="brand" href="#"
            ><img
                src="images/logo-horizontal.png?v1"
                height="34px"
                width="94px"
                :alt="t('header-logo_alt')"
            /></a>
            <div class="header-mobile-actions">
                <user-notifications variant="mobile"></user-notifications>
                <button class="navbar-toggler" type="button" @click="toggleMobile">
                    {{ t('header-menu') }} <span class="icon-hamburger"></span>
                </button>
            </div>
        </div>
        <div class="mobile-spacer" :class="{ 'with-banner': user.global_admin }"></div>
        <div class="loggedAs" v-if="user.global_admin">
            {{ t('header-viewing_as') }} <strong>{{ viewingAs }}</strong>
            <div
                class="far fa-eye"
                @click="changeShowOtherPlaceData(!showOtherPlacesData)"
            ></div>
        </div>
        <div
            class="header"
            id="mainHeader"
            v-bind:class="{ 'mobile-active': mobileOn, 'is-collapsed': sidebarCollapsed }"
        >
            <nav class="">
                <div class="brand-row">
                    <a class="brand" href="#">
                        <img class="brand-full" src="images/kevi-fl-logo.png" height="64" width="182" :alt="t('header-logo_alt')" />
                        <img class="brand-mark" src="images/icons/logo-mark-dark.svg" width="28" height="36" alt="" />
                    </a>
                    <user-notifications variant="desktop"></user-notifications>
                    <button type="button" class="sidebar-toggle" :class="{ 'is-collapsed': sidebarCollapsed }" @click="toggleSidebar" :aria-expanded="String(!sidebarCollapsed)" aria-label="Recolher ou expandir o menu">
                        <Icon icon-class="ui-layout-left" :size="3" color="#626473" />
                    </button>
                </div>
                <div class="close-mobile" @click="toggleMobile">
                    <span>{{ t('header-close_menu') }}</span>
                    <svg class="icon-close" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M18 6L6 18M6 6L18 18"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
                <div class="navbar-content">
                    <ul class="navbar-list">
                        <li
                            class="nav-item"
                            v-if="hasPermission('dashboard')"
                            name="dashboard"
                        >
                            <router-link
                                class="nav-link"
                                v-bind:to="'/dashboard'"
                                :class="{ 'menu-active': activeMenuItem === 'dashboard' }"
                                @click="handleSingleMenuClick('dashboard')"
                                exact
                            ><Icon icon-class="ui-file-check-02" size="4" />
                                {{ t('header-pdv') }}
                            </router-link>
                        </li>
                        <li
                            class="nav-item"
                            v-if="$module('tasks') && hasPermission('tasks')"
                            name="tasks"
                        >
                            <router-link
                                class="nav-link"
                                to="/tasks"
                                :class="{ 'menu-active': activeMenuItem === 'tasks' }"
                                @click="handleSingleMenuClick('tasks')"
                                exact
                            >
                                <Icon icon-class="ui-check-done-02" />
                                {{ t('header-tasks') }}
                                <span
                                    v-if="hasTasks"
                                    class="notification"
                                ></span>
                            </router-link>
                        </li>
                        <li
                            class="nav-item dropdown"
                            v-if="
                                hasPermission('reports') && $module('analytics')
                            "
                            name="reports"
                            :class="{ 'is-flyout-open': isCollapsedFlyout('reports') }"
                            @mouseenter="openCollapsedFlyout('reports', $event)"
                            @mouseleave="scheduleCloseCollapsedFlyout"
                        >
                            <a
                                class="nav-link"
                                @click="toggleDropdown('reports', $event)"
                                :class="{
                                    'dropdown-active':
                                        isDropdownParentActive('reports'),
                                    'dropdown-with-active-route':
                                        activeMenuItem &&
                                        ['rfm-report', 'orders-report', 'tasks-report', 'retention-report', 'clients-report', 'notifications-report', 'email-report', 'quotations-report'].includes(activeMenuItem)
                                }"
                            >
                                <Icon icon-class="ui-bar-chart-10" />
                                {{ t('header-metrics') }}
                            </a>
                            <ul
                                v-if="isDropdownVisible('reports')"
                                class="nav-submenu"
                                :class="{ 'is-collapsed-flyout': isCollapsedFlyout('reports') }"
                                :style="collapsedFlyoutStyle('reports')"
                                @mouseenter="keepCollapsedFlyout"
                                @mouseleave="scheduleCloseCollapsedFlyout"
                            >
                                <li v-if="$module('rfm')">
                                    <router-link
                                        class="nav-link"
                                        to="/rfm-report"
                                        :class="{ 'submenu-active': activeMenuItem === 'rfm-report' }"
                                        @click="handleMenuItemClick('reports', 'rfm-report')"
                                        exact
                                    >{{ t('header-rfm_analysis') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        class="nav-link"
                                        to="/orders/report"
                                        :class="{ 'submenu-active': activeMenuItem === 'orders-report' }"
                                        @click="handleMenuItemClick('reports', 'orders-report')"
                                    >{{ t('header-sales') }}
                                    </router-link>
                                </li>
                                <li v-if="$module('tasks')">
                                    <router-link
                                        class="nav-link"
                                        to="/tasks/report"
                                        :class="{ 'submenu-active': activeMenuItem === 'tasks-report' }"
                                        @click="handleMenuItemClick('reports', 'tasks-report')"
                                        exact
                                    >{{ t('header-tasks') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        class="nav-link"
                                        to="/retention-report"
                                        :class="{ 'submenu-active': activeMenuItem === 'retention-report' }"
                                        @click="handleMenuItemClick('reports', 'retention-report')"
                                        exact
                                    >{{ t('header-retention_cohort') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        class="nav-link"
                                        to="/clients/report"
                                        :class="{ 'submenu-active': activeMenuItem === 'clients-report' }"
                                        @click="handleMenuItemClick('reports', 'clients-report')"
                                        exact
                                    >{{ t('header-clients') }}
                                    </router-link>
                                </li>
                               <li>
                                    <router-link
                                        class="nav-link"
                                        to="/notifications"
                                        :class="{ 'submenu-active': activeMenuItem === 'notifications-report' }"
                                        @click="handleMenuItemClick('reports', 'notifications-report')"
                                        exact
                                    >{{ t('header-messages') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        class="nav-link"
                                        to="/notifications/email-report"
                                        :class="{ 'submenu-active': activeMenuItem === 'email-report' }"
                                        @click="handleMenuItemClick('reports', 'email-report')"
                                        exact
                                    >{{ t('header-email') }}
                                    </router-link>
                                </li>
                                <li v-if="$module('quotations') && hasPermission('quotations')">
                                    <router-link
                                        class="nav-link"
                                        to="/quotations"
                                        :class="{ 'submenu-active': activeMenuItem === 'quotations-report' }"
                                        @click="handleMenuItemClick('reports', 'quotations-report')"
                                        exact
                                    >{{ t('header-quotations') }}
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <li
                            class="nav-item dropdown"
                            v-if="
                                $module('forms') &&
                                (hasPermission('forms') || hasPermission('inbox'))
                            "
                            name="forms"
                            :class="{ 'is-flyout-open': isCollapsedFlyout('forms') }"
                            @mouseenter="openCollapsedFlyout('forms', $event)"
                            @mouseleave="scheduleCloseCollapsedFlyout"
                        >
                            <a
                                class="nav-link"
                                @click.prevent="toggleDropdown('forms', $event)"
                                :class="{
                                    'dropdown-active':
                                        isDropdownParentActive('forms'),
                                    'dropdown-with-active-route':
                                        activeMenuItem &&
                                        ['forms-manage', 'inbox'].includes(activeMenuItem)
                                }"
                            >
                                <Icon icon-class="ui-file-search-03" size="4" />
                                {{ t('header-forms') }}
                                <span
                                    v-if="newMessages > 0"
                                    class="notification"
                                ></span>
                            </a>
                            <ul
                                v-if="isDropdownVisible('forms')"
                                class="nav-submenu"
                                :class="{ 'is-collapsed-flyout': isCollapsedFlyout('forms') }"
                                :style="collapsedFlyoutStyle('forms')"
                                @mouseenter="keepCollapsedFlyout"
                                @mouseleave="scheduleCloseCollapsedFlyout"
                            >
                                <li v-if="hasPermission('forms')">
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/forms'"
                                        :class="{ 'submenu-active': activeMenuItem === 'forms-manage' }"
                                        @click="handleMenuItemClick('forms', 'forms-manage')"
                                        exact
                                    >{{ t('header-forms_manage') }}
                                    </router-link>
                                </li>
                                <li v-if="hasPermission('inbox')">
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/inbox'"
                                        :class="{ 'submenu-active': activeMenuItem === 'inbox' }"
                                        @click="handleMenuItemClick('forms', 'inbox')"
                                        exact
                                    >
                                        {{ t('header-forms_answers') }}&nbsp;
                                        <div
                                            v-if="newMessages > 0"
                                            class="badge badge-danger badge-pill"
                                        >
                                            {{ newMessages }}
                                        </div>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <li
                            class="nav-item dropdown"
                            v-if="hasPermission('clients')"
                            name="clients"
                            :class="{ 'is-flyout-open': isCollapsedFlyout('clients') }"
                            @mouseenter="openCollapsedFlyout('clients', $event)"
                            @mouseleave="scheduleCloseCollapsedFlyout"
                        >
                            <a
                                class="nav-link"
                                @click.prevent="toggleDropdown('clients', $event)"
                                :class="{
                                    'dropdown-active':
                                        isDropdownParentActive('clients'),
                                    'dropdown-with-active-route':
                                        activeMenuItem &&
                                        ['clients-list', 'coupons', 'segments', 'orders'].includes(activeMenuItem)
                                }"
                            >
                                <Icon icon-class="ui-users-01" />
                                {{ t('header-contacts') }}
                            </a>
                            <ul
                                v-if="isDropdownVisible('clients')"
                                class="nav-submenu"
                                :class="{ 'is-collapsed-flyout': isCollapsedFlyout('clients') }"
                                :style="collapsedFlyoutStyle('clients')"
                                @mouseenter="keepCollapsedFlyout"
                                @mouseleave="scheduleCloseCollapsedFlyout"
                            >
                                <li>
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/clients'"
                                        :class="{ 'submenu-active': activeMenuItem === 'clients-list' }"
                                        @click="handleMenuItemClick('clients', 'clients-list')"
                                        exact
                                    >{{ t('header-contact_base') }}
                                    </router-link>
                                </li>
                                <li
                                    v-if="
                                        hasPermission('coupons') &&
                                        $module('coupons')
                                    "
                                >
                                    <router-link
                                        class="nav-link"
                                        to="/coupons/report"
                                        :class="{ 'submenu-active': activeMenuItem === 'coupons' }"
                                        @click="handleMenuItemClick('clients', 'coupons')"
                                        exact
                                    >{{ t('header-coupons_list') }}
                                    </router-link>
                                </li>
                                <li
                                    v-if="
                                        hasPermission('segments') &&
                                        $module('segments')
                                    "
                                >
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/segments'"
                                        :class="{ 'submenu-active': activeMenuItem === 'segments' }"
                                        @click="handleMenuItemClick('clients', 'segments')"
                                        exact
                                    >{{ t('header-segments') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/orders'"
                                        :class="{ 'submenu-active': activeMenuItem === 'orders' }"
                                        @click="handleMenuItemClick('clients', 'orders')"
                                    >{{ t('header-sales') }}
                                    </router-link>
                                </li>
                            </ul>
                        </li>

                        <li
                            class="nav-item dropdown"
                            v-if="
                                hasPermission('automations') &&
                                ($module('automations') || $module('campaigns'))
                            "
                            name="automations"
                        >
                            <router-link
                                class="nav-link"
                                to="/automations"
                                :class="{ 'menu-active': activeMenuItem === 'automations' }"
                                @click="handleSingleMenuClick('automations')"
                                exact
                            ><Icon icon-class="ui-target-04" />
                                {{ t('header-marketing_actions') }}
                            </router-link>
                        </li>

                        <li
                            class="nav-item dropdown"
                            v-if="hasPermission('benefit_programs')"
                            name="benefits"
                        >
                            <router-link
                                class="nav-link"
                                to="/benefits"
                                :class="{ 'menu-active': activeMenuItem === 'benefits' }"
                                @click="handleSingleMenuClick('benefits')"
                                exact
                            ><Icon icon-class="ui-sale-03" />
                                {{ t('header-benefits_center') }}
                            </router-link>
                        </li>

                        <li
                            class="nav-item dropdown"
                            name="settings"
                            :class="{ 'is-flyout-open': isCollapsedFlyout('settings') }"
                            @mouseenter="openCollapsedFlyout('settings', $event)"
                            @mouseleave="scheduleCloseCollapsedFlyout"
                            v-if="settingsModule"
                        >
                            <a
                                class="nav-link"
                                @click="toggleDropdown('settings', $event)"
                                :class="{
                                    'dropdown-active':
                                        isDropdownParentActive('settings'),
                                    'dropdown-with-active-route':
                                        activeMenuItem &&
                                        ['connections', 'data-sets', 'settings-whatsapp', 'balance', 'custom-events', 'client-fields', 'order-fields', 'quotation-fields', 'order-status', 'quotation-status', 'notification-schedule', 'utm-auto', 'translations', 'agent-authorizations', 'products', 'files-gallery', 'client-deletion', 'import-history', 'settings-users'].includes(activeMenuItem)
                                }"
                            >
                                <Icon icon-class="ui-settings-02" />
                                {{ t('header-settings') }}
                            </a>
                            <ul
                                v-if="isDropdownVisible('settings')"
                                class="nav-submenu"
                                :class="{ 'is-collapsed-flyout': isCollapsedFlyout('settings') }"
                                :style="collapsedFlyoutStyle('settings')"
                                @mouseenter="keepCollapsedFlyout"
                                @mouseleave="scheduleCloseCollapsedFlyout"
                            >
                                <li v-if="user.global_admin || hasPermission('account.users.manage')">
                                    <router-link
                                        class="nav-link"
                                        to="/settings/users"
                                        :class="{ 'submenu-active': activeMenuItem === 'settings-users' }"
                                        @click="handleMenuItemClick('settings', 'settings-users')"
                                    >{{ t('header-users') }}</router-link>
                                </li>
                                <li v-if="($module('whatsapp') || $module('rcs')) && hasPermission('configs')">
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/connections'"
                                        :class="{ 'submenu-active': activeMenuItem === 'connections' }"
                                        @click="handleMenuItemClick('settings', 'connections')"
                                        exact
                                    >{{ t('header-connections') }}
                                    </router-link>
                                </li>
                                <li>
                                  <router-link
                                    class="nav-link"
                                    v-bind:to="'/data-sets'"
                                    :class="{ 'submenu-active': activeMenuItem === 'data-sets' }"
                                    @click="handleMenuItemClick('settings', 'data-sets')"
                                    exact
                                  >{{ t('header-data_sets') }}
                                  </router-link>
                                </li>
                                <li
                                    v-if="
                                        $module('sms') &&
                                        hasPermission('balance')
                                    "
                                >
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/balance'"
                                        :class="{ 'submenu-active': activeMenuItem === 'balance' }"
                                        @click="handleMenuItemClick('settings', 'balance')"
                                        exact
                                    >{{ t('header-credits') }}
                                    </router-link>
                                </li>
                                <li
                                    v-if="
                                        $module('custom_events') &&
                                        hasPermission('clients')
                                    "
                                >
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/custom-events'"
                                        :class="{ 'submenu-active': activeMenuItem === 'custom-events' }"
                                        @click="handleMenuItemClick('settings', 'custom-events')"
                                        exact
                                    >{{ t('header-custom_events') }}
                                    </router-link>
                                </li>
                                <li
                                    v-if="
                                        $module('client_fields') &&
                                        hasPermission('configs')
                                    "
                                >
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/settings/client-fields'"
                                        :class="{ 'submenu-active': activeMenuItem === 'client-fields' }"
                                        @click="handleMenuItemClick('settings', 'client-fields')"
                                        exact
                                    >{{ t('header-client_fields') }}
                                    </router-link>
                                </li>
                                <li
                                    v-if="
                                        $module('client_fields') &&
                                        hasPermission('configs')
                                    "
                                >
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/settings/order-fields'"
                                        :class="{ 'submenu-active': activeMenuItem === 'order-fields' }"
                                        @click="handleMenuItemClick('settings', 'order-fields')"
                                        exact
                                    >{{ t('header-order_fields') }}
                                    </router-link>
                                </li>
                                <li v-if="$module('quotations')
                                    && hasPermission('quotations')
                                    && hasPermission('configs')
                                ">
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/settings/quotation-fields'"
                                        :class="{ 'submenu-active': activeMenuItem === 'quotation-fields' }"
                                        @click="handleMenuItemClick('settings', 'quotation-fields')"
                                        exact
                                    >{{ t('header-quotation_fields') }}
                                    </router-link>
                                </li>
                                <li
                                    v-if="
                                        $module('order_status') &&
                                        hasPermission('configs')
                                    "
                                >
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/settings/order-status'"
                                        :class="{ 'submenu-active': activeMenuItem === 'order-status' }"
                                        @click="handleMenuItemClick('settings', 'order-status')"
                                        exact
                                    >{{ t('header-order_status') }}
                                    </router-link>
                                </li>
                                <li v-if="$module('quotations')
                                    && hasPermission('quotations')
                                    && hasPermission('configs')
                                ">
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/settings/quotation-status'"
                                        :class="{ 'submenu-active': activeMenuItem === 'quotation-status' }"
                                        @click="handleMenuItemClick('settings', 'quotation-status')"
                                        exact
                                    >{{ t('header-quotation_status') }}
                                    </router-link>
                                </li>
                                <li
                                    v-if="
                                        $module('automations') &&
                                        hasPermission('configs')
                                    "
                                >
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/notification-schedule'"
                                        :class="{ 'submenu-active': activeMenuItem === 'notification-schedule' }"
                                        @click="handleMenuItemClick('settings', 'notification-schedule')"
                                        exact
                                    >{{ t('header-notification_schedule') }}
                                    </router-link>
                                </li>
                                <li
                                    v-if="
                                        $module('automations') &&
                                        hasPermission('configs')
                                    "
                                >
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/settings/utm-auto'"
                                        :class="{ 'submenu-active': activeMenuItem === 'utm-auto' }"
                                        @click="handleMenuItemClick('settings', 'utm-auto')"
                                        exact
                                    >{{ t('header-utm_auto') }}
                                    </router-link>
                                </li>
                                <li v-if="hasPermission('configs')">
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/settings/agent-authorizations'"
                                        :class="{ 'submenu-active': activeMenuItem === 'agent-authorizations' }"
                                        @click="handleMenuItemClick('settings', 'agent-authorizations')"
                                        exact
                                    >{{ t('header-agent_authorizations') }}
                                    </router-link>
                                </li>
                                <li
                                    v-if="
                                        $module(
                                            'product_purchase_prediction',
                                        ) && hasPermission('configs')
                                    "
                                >
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/settings/products'"
                                        :class="{ 'submenu-active': activeMenuItem === 'products' }"
                                        @click="handleMenuItemClick('settings', 'products')"
                                        exact
                                    >{{ t('header-products') }}
                                    </router-link>
                                </li>
                                <li
                                >
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/files-gallery'"
                                        :class="{ 'submenu-active': activeMenuItem === 'files-gallery' }"
                                        @click="handleMenuItemClick('settings', 'files-gallery')"
                                        exact
                                    >{{ t('header-files_gallery') }}
                                    </router-link>
                                </li>
                                <li
                                    v-if="hasPermission({permission:'clients', callback: (p) => parseInt(p.options?.deletion) === 1 })"
                                >
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/clients/deletion'"
                                        :class="{ 'submenu-active': activeMenuItem === 'client-deletion' }"
                                        @click="handleMenuItemClick('settings', 'client-deletion')"
                                        exact
                                    >{{ t('header-client_base_management') }}
                                    </router-link>
                                </li>
                                <li v-if="hasPermission('configs')">
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/imports'"
                                        :class="{ 'submenu-active': activeMenuItem === 'import-history' }"
                                        @click="handleMenuItemClick('settings', 'import-history')"
                                        exact
                                    >{{ t('header-import_history') }}
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <li
                            v-if="user.global_admin"
                            class="nav-item dropdown"
                            name="places"
                            :class="{ 'is-flyout-open': isCollapsedFlyout('places') }"
                            @mouseenter="openCollapsedFlyout('places', $event)"
                            @mouseleave="scheduleCloseCollapsedFlyout"
                        >
                            <a
                                class="nav-link"
                                @click="toggleDropdown('places', $event)"
                                :class="{
                                    'dropdown-active':
                                        isDropdownParentActive('places'),
                                    'dropdown-with-active-route':
                                        activeMenuItem &&
                                        ['places-list', 'plans', 'usage-report', 'email-generator'].includes(activeMenuItem)
                                }"
                            >
                                <Icon icon-class="ui-building-01" />
                                {{ t('header-establishments') }}
                            </a>
                            <ul
                                v-if="isDropdownVisible('places')"
                                class="nav-submenu"
                                :class="{ 'is-collapsed-flyout': isCollapsedFlyout('places') }"
                                :style="collapsedFlyoutStyle('places')"
                                @mouseenter="keepCollapsedFlyout"
                                @mouseleave="scheduleCloseCollapsedFlyout"
                            >
                                <li>
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/places'"
                                        :class="{ 'submenu-active': activeMenuItem === 'places-list' }"
                                        @click="handleMenuItemClick('places', 'places-list')"
                                        exact
                                    >{{ t('header-list') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/plans'"
                                        :class="{ 'submenu-active': activeMenuItem === 'plans' }"
                                        @click="handleMenuItemClick('places', 'plans')"
                                        exact
                                    >{{ t('header-plans') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="placeUsageReportUrl"
                                        :class="{ 'submenu-active': activeMenuItem === 'usage-report' }"
                                        @click="handleMenuItemClick('places', 'usage-report')"
                                        exact
                                    >{{ t('header-adoption_report') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/settings/translations'"
                                        :class="{ 'submenu-active': activeMenuItem === 'translations' }"
                                        @click="handleMenuItemClick('settings', 'translations')"
                                        exact
                                    >{{ t('header-translations') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        class="nav-link"
                                        v-bind:to="'/places/email-generator'"
                                        :class="{ 'submenu-active': activeMenuItem === 'email-generator' }"
                                        @click="handleMenuItemClick('places', 'email-generator')"
                                        exact
                                    >{{ t('header-email_generator') }}
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown" name="account"
                            :class="{ 'is-flyout-open': isCollapsedFlyout('account') }"
                            @mouseenter="openCollapsedFlyout('account', $event)"
                            @mouseleave="scheduleCloseCollapsedFlyout"
                        >
                            <a
                                class="nav-link"
                                @click="toggleDropdown('account', $event)"
                                :class="{
                                    'dropdown-active':
                                        isDropdownParentActive('account'),
                                    'dropdown-with-active-route':
                                        activeMenuItem &&
                                        ['account-password', 'account-2fa'].includes(activeMenuItem)
                                }"
                            >
                                <Icon icon-class="ui-user-01" size="4" />
                                {{ t('header-my_account') }}
                            </a>
                            <ul
                                v-if="isDropdownVisible('account')"
                                class="nav-submenu"
                                :class="{ 'is-collapsed-flyout': isCollapsedFlyout('account') }"
                                :style="collapsedFlyoutStyle('account')"
                                @mouseenter="keepCollapsedFlyout"
                                @mouseleave="scheduleCloseCollapsedFlyout"
                            >
                                <li class="line-ignore">
                                    <router-link
                                        class="nav-link"
                                        to=""
                                        style="cursor: default"
                                    ><small
                                    >{{ t('header-hello', { 0: user.name }) }}</small
                                    ></router-link
                                    >
                                </li>
                                <li>
                                    <router-link
                                        class="nav-link"
                                        to="/account"
                                        :class="{ 'submenu-active': activeMenuItem === 'account-password' }"
                                        @click="handleMenuItemClick('account', 'account-password')"
                                    >{{ t('header-my_profile') }}
                                    </router-link>
                                </li>
                                <li>
                                    <a
                                        class="nav-link"
                                        @click.prevent="
                                            $refs.confirm_logout.open()
                                        "
                                    >{{ t('header-logout') }}</a
                                    >
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown" name="support">
                            <router-link
                                class="nav-link"
                                to="/support"
                                :class="{ 'menu-active': activeMenuItem === 'support' }"
                                @click="handleSingleMenuClick('support')"
                                exact
                            >
                                <Icon icon-class="ui-help-circle" />
                                {{ t('header-support') }}
                            </router-link>
                        </li>
                    </ul>
                    <div class="insertion" v-if="insertion">
                        <div class="insertion-top">
                            <!-- i18n-validator-ignore-next-line: runtime CMS field -->
                            <h3> {{ insertion.fields.titulo }}</h3>
                            <!-- i18n-validator-ignore-next-line: runtime CMS field -->
                            <p> {{ insertion.fields.subtitulo }}</p>
                        </div>
                        <iframe class="insertion-iframe" v-if="insertion" :src="getUrl(insertion.id, 'corpo')"
                                ref="insertion"
                                style="width: 100%; height: 250px;"/>
                    </div>
                </div>
            </nav>
        </div>
        <confirm
            id="confirm_logout"
            ref="confirm_logout"
            @confirm="$router.push('/logout')"
        >
            <template slot="title">{{ t('header-logout_title') }}</template>
            <template slot="body">
                {{ t('header-logout_message') }}
            </template>
            <template slot="cancel">{{ t('header-no') }}</template>
            <template slot="confirm">{{ t('header-yes') }}</template>
        </confirm>
    </div>
</template>

<script>
import debounce from "../../helpers/debounce";
import keviApi from "../../keviApi";
import {getSmartInsertions, getSmartInsertionHtmlUrl} from "../../keviClientSDK";
import Icon from "../icon/icon.vue";

export default {
    name: "main-header",
    components: {
        Icon,
    },
    props: {
        route: Array,
    },
    data: function () {
        return {
            visibleDropdowns: [],
            activeDropdown: null,
            activeMenuItem: null,
            hasTasks: false,
            mobileOn: false,
            sidebarCollapsed: window.localStorage.getItem("kevi-sidebar-collapsed") === "1",
            appMode: window.appMode,
            insertions: [],
            flyoutName: null,
            flyoutStyle: {},
            flyoutCloseTimer: null,
        };
    },
    computed: {
        isDropdownParentActive() {
            return (dropdownName) => {
                return this.activeDropdown === dropdownName;
            };
        },
        place() {
            return this.$store.state.place;
        },
        keviToken() {
            return this.$store.state.keviToken;
        },
        insertion() {
            if (this.insertions && this.insertions.length > 0) {
                return this.insertions[this.insertions.length - 1];
            }
            return null;
        },
        settingsModule() {
            return [
                "data-sets",
                "connections",
                "rewards",
                "coupons",
                "sms",
                "email",
                "custom_events",
                "order_status",
            ].some((name) => this.$module(name));
        },
        viewingAs() {
            return this.showOtherPlacesData
                ? this.place.name
                : this.place.name.replace(/[^\s]/g, "*");
        },
        user() {
            return this.$store.state.user;
        },
        newMessages() {
            return this.$store.state.inbox.newMessages;
        },
        showOtherPlacesData() {
            return this.$store.state.showOtherPlacesData;
        },
        placeUsageReportUrl() {
            let start = new Date();
            start.setDate(start.getDate() - 15);
            let end = new Date();
            end.setHours(23);
            end.setMinutes(59);
            end.setSeconds(59);
            end.setMilliseconds(999);
            return this.$router.resolve({
                path: "/places/usage-report",
                query: {
                    filter: JSON.stringify({
                        period: {
                            start: start.toISOString(),
                            end: end.toISOString(),
                        },
                    }),
                },
            }).location;
        },
    },
    mounted() {
        this.syncSidebarClass();
        this._onSidebarResize = () => this.syncSidebarClass();
        window.addEventListener("resize", this._onSidebarResize);
        this.updateInboxCounting();
        this.updateTasksCount();
        this.loadInsertions();
        this.detectActiveMenuFromRoute();
        window.setInterval(() => {
            this.loadInsertions();
        }, 1000*60*20); // 20 minutes
    },
    beforeDestroy() {
        window.removeEventListener("resize", this._onSidebarResize);
        document.body.classList.remove("sidebar-collapsed");
        clearTimeout(this.flyoutCloseTimer);
    },
    methods: {
        getUrl(insertion, field) {
            return getSmartInsertionHtmlUrl(insertion, field);
        },
        async loadInsertions() {
            if (this.keviToken) {
                const insertions = await getSmartInsertions("sidebar");
                this.insertions = insertions;
            }
        },
        changeShowOtherPlaceData(value) {
            this.$store.commit("setShowOtherPlacesData", value);
        },
        updateInboxCounting: debounce(
            function () {
                if (this.hasPermission("inbox")) {
                    this.$store.dispatch("inbox/checkNewMessages");
                    window.setTimeout(
                        () => {
                            this.updateInboxCounting();
                        },
                        1000 * 60 * 3,
                    );
                }
            },
            5000,
            true,
        ),
        updateTasksCount: debounce(
            function () {
                if (this.hasPermission("tasks")) {
                    const options = keviApi.getOptions("tasks", "GET", {
                        filters: {status: "pending", assignee: this.user.id},
                    });
                    this.$http(options).then((response) => {
                        this.hasTasks = response.body.length > 0;
                    });
                    window.setTimeout(
                        () => {
                            this.updateTasksCount();
                        },
                        1000 * 60 * 3,
                    );
                }
            },
            5000,
            true,
        ),
        isCollapsedDesktop: function () {
            return this.sidebarCollapsed && window.innerWidth > 700;
        },
        isCollapsedFlyout: function (name) {
            return this.isCollapsedDesktop() && this.flyoutName === name;
        },
        collapsedFlyoutStyle: function (name) {
            return this.isCollapsedFlyout(name) ? this.flyoutStyle : null;
        },
        openCollapsedFlyout: function (name, event) {
            if (!this.isCollapsedDesktop() || !event || !event.currentTarget) {
                return;
            }
            clearTimeout(this.flyoutCloseTimer);
            const rect = event.currentTarget.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.top - 12;
            const spaceAbove = rect.bottom - 12;
            const openUpward = spaceBelow < 220 && spaceAbove > spaceBelow;
            const maxHeight = Math.min(openUpward ? spaceAbove : spaceBelow, 480);
            this.flyoutName = name;
            this.flyoutStyle = openUpward
                ? {
                      left: Math.round(rect.right + 8) + "px",
                      top: "auto",
                      bottom: Math.round(window.innerHeight - rect.bottom) + "px",
                      maxHeight: Math.max(160, Math.round(maxHeight)) + "px",
                  }
                : {
                      left: Math.round(rect.right + 8) + "px",
                      top: Math.round(rect.top) + "px",
                      bottom: "auto",
                      maxHeight: Math.max(160, Math.round(maxHeight)) + "px",
                  };
        },
        keepCollapsedFlyout: function () {
            clearTimeout(this.flyoutCloseTimer);
        },
        scheduleCloseCollapsedFlyout: function () {
            if (!this.isCollapsedDesktop()) {
                return;
            }
            clearTimeout(this.flyoutCloseTimer);
            this.flyoutCloseTimer = setTimeout(() => {
                this.closeCollapsedFlyout();
            }, 220);
        },
        closeCollapsedFlyout: function () {
            clearTimeout(this.flyoutCloseTimer);
            this.flyoutName = null;
            this.flyoutStyle = {};
        },
        toggleDropdown: function (dropdown, event) {
            if (this.isCollapsedDesktop()) {
                if (this.flyoutName === dropdown) {
                    this.closeCollapsedFlyout();
                    return;
                }
                const target = event && (event.currentTarget || event.target);
                const item = target && target.closest ? target.closest(".nav-item") : null;
                if (item) {
                    this.openCollapsedFlyout(dropdown, { currentTarget: item });
                }
                return;
            }
            this.closeCollapsedFlyout();
            if (this.activeDropdown === dropdown) {
                this.activeDropdown = null;
                this.visibleDropdowns = [];
            } else {
                this.activeDropdown = dropdown;
                this.visibleDropdowns = [dropdown];
            }
        },

        handleMenuItemClick: function(dropdownName, itemName) {
            this.activeDropdown = dropdownName;
            this.activeMenuItem = itemName;
            if (dropdownName) {
                this.visibleDropdowns = [dropdownName];
            }
            this.closeCollapsedFlyout();
            if (this.mobileOn) {
                this.mobileOn = false;
            }
        },

        handleSingleMenuClick: function(itemName) {
            this.activeDropdown = null;
            this.activeMenuItem = itemName;
            this.visibleDropdowns = [];
            this.closeCollapsedFlyout();
        },

        isCurrentRoute(routePath) {
            return this.$route.path.split("?")[0].split("#")[0] === routePath;
        },

        detectActiveMenuFromRoute() {
            const currentPath = this.$route.path.split("?")[0].split("#")[0];

            // Array de rotas ordenado por especificidade (mais específicas primeiro)
            // Ordered by specificity (most specific first) so longer paths match before shorter ones
            const routeMap = [
                // Rotas mais específicas primeiro (mais segmentos de path)
                { path: "/settings/client-fields", dropdown: "settings", item: "client-fields" },
                { path: "/settings/order-fields", dropdown: "settings", item: "order-fields" },
                { path: "/settings/quotation-fields", dropdown: "settings", item: "quotation-fields" },
                { path: "/settings/order-status", dropdown: "settings", item: "order-status" },
                { path: "/settings/quotation-status", dropdown: "settings", item: "quotation-status" },
                { path: "/settings/utm-auto", dropdown: "settings", item: "utm-auto" },
                { path: "/settings/agent-authorizations", dropdown: "settings", item: "agent-authorizations" },
                { path: "/settings/translations", dropdown: "settings", item: "translations" },
                { path: "/settings/products", dropdown: "settings", item: "products" },
                { path: "/tasks/report", dropdown: "reports", item: "tasks-report" },
                { path: "/orders/report", dropdown: "reports", item: "orders-report" },
                { path: "/clients/report", dropdown: "reports", item: "clients-report" },
                { path: "/notifications/email-report", dropdown: "reports", item: "email-report" },
                { path: "/clients/deletion", dropdown: "settings", item: "client-deletion" },
                { path: "/coupons/report", dropdown: "clients", item: "coupons" },
                { path: "/places/usage-report", dropdown: "places", item: "usage-report" },
                { path: "/places/email-generator", dropdown: "places", item: "email-generator" },
                { path: "/account/2fa", dropdown: "account", item: "account-2fa" },

                // Rotas menos específicas depois
                { path: "/dashboard", dropdown: null, item: "dashboard" },
                { path: "/tasks", dropdown: null, item: "tasks" },
                { path: "/forms", dropdown: "forms", item: "forms-manage" },
                { path: "/automations", dropdown: null, item: "automations" },
                { path: "/benefits", dropdown: null, item: "benefits" },
                { path: "/support", dropdown: null, item: "support" },
                { path: "/segments", dropdown: "clients", item: "segments" },
                { path: "/inbox", dropdown: "forms", item: "inbox" },
                { path: "/orders", dropdown: "clients", item: "orders" },
                { path: "/clients", dropdown: "clients", item: "clients-list" },
                { path: "/rfm-report", dropdown: "reports", item: "rfm-report" },
                { path: "/retention-report", dropdown: "reports", item: "retention-report" },
                { path: "/notifications", dropdown: "reports", item: "notifications-report" },
                { path: "/quotations", dropdown: "reports", item: "quotations-report" },
                { path: "/data-sets", dropdown: "settings", item: "data-sets" },
                { path: "/connections", dropdown: "settings", item: "connections" },
                { path: "/places", dropdown: "places", item: "places-list" },
                { path: "/plans", dropdown: "places", item: "plans" },
                { path: "/balance", dropdown: "settings", item: "balance" },
                { path: "/custom-events", dropdown: "settings", item: "custom-events" },
                { path: "/notification-schedule", dropdown: "settings", item: "notification-schedule" },
                { path: "/files-gallery", dropdown: "settings", item: "files-gallery" },
                { path: "/settings/users", dropdown: "settings", item: "settings-users" },
                { path: "/account", dropdown: "account", item: "account-password" }
            ];

            // Exact match first; otherwise longest prefix (e.g. /forms/:id).
            const match =
                routeMap.find((route) => route.path === currentPath) ||
                routeMap
                    .filter((route) => currentPath.startsWith(route.path + "/"))
                    .sort((a, b) => b.path.length - a.path.length)[0];

            if (match) {
                this.activeMenuItem = match.item;
                if (match.dropdown) {
                    this.activeDropdown = match.dropdown;
                    this.visibleDropdowns = [match.dropdown];
                } else {
                    this.activeDropdown = null;
                    this.visibleDropdowns = [];
                }
            } else {
                this.activeMenuItem = null;
                this.activeDropdown = null;
                this.visibleDropdowns = [];
            }
        },
        isDropdownVisible: function (dropdown) {
            if (this.isCollapsedDesktop()) {
                return this.flyoutName === dropdown;
            }
            return this.visibleDropdowns.indexOf(dropdown) !== -1;
        },
        toggleMobile: function () {
            this.mobileOn = !this.mobileOn;
        },
        toggleSidebar: function () {
            this.setSidebarCollapsed(!this.sidebarCollapsed);
        },
        setSidebarCollapsed: function (collapsed) {
            this.closeCollapsedFlyout();
            this.sidebarCollapsed = collapsed;
            window.localStorage.setItem("kevi-sidebar-collapsed", collapsed ? "1" : "0");
            this.syncSidebarClass();
        },
        syncSidebarClass: function () {
            const collapsed = this.sidebarCollapsed && window.innerWidth > 700;
            document.body.classList.toggle("sidebar-collapsed", collapsed);
            if (!collapsed) {
                this.closeCollapsedFlyout();
            }
            this.$forceUpdate();
        },
        foundUser: function (user) {
            this.$emit("found-user", user);
        },
        hasPermission(options) {
            let permission, callback;
            if (typeof options === "string") {
                permission = options;
                callback = () => true;
            } else {
                permission = options?.permission;
                callback = options?.callback;
            }
            if (this.user) {
                const userPermission = this.user.permissions[permission];
                if(userPermission) {
                    return userPermission.enabled && (!callback || callback(userPermission));
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
    watch: {
        user: function () {
            this.updateInboxCounting();
        },
        route: function () {
            this.mobileOn = false;
            this.detectActiveMenuFromRoute();
        },
        $route: function () {
            this.detectActiveMenuFromRoute();
        },
    },
};
</script>

<style lang="less">
@import url("./../../mixins.less");

ul.navbar-list {
    li {
        a {
            span.ui-icon {
                margin-right: 12px;
            }
        }
    }
}

.insertion {
    width: 100%;
    .insertion-top {
        padding: 10px;
        h3 {
            font-size: 16px;
            color: #333;
        }
        p {
            font-size: 13px;
            color: #888;
            margin-bottom: 0;
        }
    }
    iframe {
        border: none;
        overflow: hidden;
        display: block;
        margin-bottom: 0;
    }
}

.loggedAs {
    position: relative;
    // margin-left: -50px !important;
    margin-top: -20px;
    margin-bottom: 20px;
    padding-left: 20px;
    width: calc(~"100vw - 230px") !important;
    height: 50px;
    background: var(--primary);
    color: #fff;
    z-index: 8;
    line-height: 50px;
    padding-left: 20px;
    @media (max-width: 700px) {
        position: fixed;
        top: 56px;
        left: 0;
        width: 100% !important;
        margin: 0 !important;
        height: 40px;
        line-height: 40px;
        font-size: 13px;
        z-index: 8;
        box-sizing: border-box;
    }
}

.mobile-spacer {
    display: none;
}

.sidebar-toggle {
    display: none;
}

.header-mobile-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.header-mobile {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 56px;
    background: var(--primary);
    display: none;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    box-sizing: border-box;
    z-index: 10;

    .brand {
        height: 34px;
        display: inline-block;
        margin-top: 3px;
    }
    .navbar-toggler {
        float: none;
        margin: 0;
        color: #fff;
        font-size: 16px;
        padding: 0;
        background: transparent;
        border: 0;
        span {
            &:before, &:after {
                content: "";
                display: block;
                position: absolute;
                top: -6px;
                background: #DCDCDC;
                height: 2px;
                width: 100%;
            }
            &:after {
                top: 100%;
                margin-top: 4px;
            }
            float: right;
            position: relative;
            background: #DCDCDC;
            height: 2px;
            width: 21px;
            border-radius: 2px;
            margin-left: 10px;
            margin-top: 6px;
        }
    }
}

nav {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .navbar-content {
        margin-top: 30px;
        flex-grow: 1;
    }
}

.header {
    border-right: 1px solid #E7E7E7;
    &:extend(.scrollbar);
    overflow: auto;
    float: left;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 230px;
    z-index: 9;
    padding: 0;
    transition: width .32s cubic-bezier(.22, 1, .36, 1), background-color .32s ease;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #ffffff;

    a, .btn, button {
        color: #7C7C7C;
    }
    .close-mobile {
        display: none;
    }

    .brand-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 4px;
        flex: none;
        padding: 20px 10px 4px 12px;
        min-height: 84px;
        box-sizing: border-box;
    }

    .brand {
        position: relative;
        flex: 1;
        min-width: 0;
        width: auto;
        height: 48px;
        min-height: 48px;
        margin: 0;
        display: flex;
        align-items: center;
        .brand-full {
            margin: 0;
            width: auto;
            max-width: 100%;
            height: 48px;
            object-fit: contain;
            object-position: left center;
            transform-origin: left center;
            visibility: visible;
            transition:
                opacity .28s ease,
                transform .32s cubic-bezier(.22, 1, .36, 1),
                filter .28s ease,
                visibility 0s linear 0s;
        }
        .brand-mark {
            display: block;
            position: absolute;
            left: 0;
            top: 50%;
            width: 28px;
            height: 36px;
            max-width: none;
            margin: 0;
            opacity: 0;
            pointer-events: none;
            transform: translateY(-50%) scale(0.88);
            transform-origin: center center;
            transition:
                opacity .28s ease,
                transform .32s cubic-bezier(.22, 1, .36, 1);
        }
    }

    ul {
        list-style: none;
        padding: 0;
        margin-top: 0;

        li.dropdown {
            ul {
                li {
                    .nav-link {
                        padding-left: 30px !important;
                        padding-right: 0 !important;
                    }
                }
            }
        }

        li.nav-item {
            padding: 0 10px;
            margin-bottom: 5px;
            border-bottom: none;
            cursor: pointer;
            position: relative;

            .nav-link {
                line-height: 20px !important;
            }
            > a.nav-link {
                display: flex;
                align-items: center;
                padding: 8px 10px;
                font-size: 12.5px;
                font-weight: 500;
                border-radius: 8px;
                transition: background-color 0.2s ease, color 0.2s ease;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                span[class^="icon"], .fa {
                    flex-shrink: 0;
                    width: 20px;
                    margin-right: 10px;
                    font-size: 15px;
                    text-align: left;
                    color: #555;
                    transition: color 0.2s ease;
                }

                .notification {
                    background: var(--danger);
                    margin-left: auto;
                    margin-top: 1.5px;
                    width: 7px;
                    height: 7px;
                    border-radius: 100%;
                }
            }

            > a.nav-link:hover,
            > a.nav-link.router-link-active {
                background-color: #EFEFEF;
                color: #000;
                font-weight: 600;
            }

            > a.nav-link.dropdown-active {
                font-weight: 500;
            }

            &.dropdown {
                ul {
                    margin-left: 0;
                    padding: 8px 0 5px 0;
                    transition: none;
                    position: relative;

                    // &:before {
                    //     content: '';
                    //     position: absolute;
                    //     left: 15px;
                    //     top: 0;
                    //     bottom: 19px;
                    //     width: 1px;
                    //     background-color: #DCDCDC;
                    // }

                    li {
                        position: relative;
                        padding-left: 10px;

                        a {
                            padding: 5px 10px 5px 42px;
                            font-size: 12.5px;
                            font-weight: 500;

                            &.router-link-active {
                                font-weight: 600;
                                color: #000;
                            }
                        }

                        &:not(.line-ignore):before {
                            content: '';
                            position: absolute;
                            left: 15px;
                            top: -23px;
                            width: 15px;
                            height: 39px;
                            border: 1px solid;
                            border-color: transparent transparent #e6e6e6 #e6e6e6;
                            z-index: -1;
                            border-radius: 0 0 0 12px;

                        }

                        a.nav-link.submenu-active {
                            font-weight: 600 !important;
                            color: #000 !important;
                        }
                    }
                }
            }
        }
    }

    .navbar-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .nav-item > a.nav-link.menu-active {
            background-color: #EFEFEF !important;
            font-weight: 600 !important;
            color: #000;
        }

        .nav-item .nav-link.menu-active {
            background-color: #EFEFEF !important;
            font-weight: 600 !important;
            color: #000;
        }

        .nav-item > a.nav-link.menu-active.dropdown-active {
            background-color: #EFEFEF !important;
            font-weight: 600 !important;
            color: #000;
        }

        .nav-item > a.nav-link.dropdown-with-active-route {
            background-color: #EFEFEF !important;
            font-weight: 600 !important;
            color: #000;
        }
    }
}

.header .nav-item > a.nav-link.menu-active,
.header .nav-item a.nav-link.menu-active {
    background-color: #EFEFEF !important;
    font-weight: 600 !important;
    color: #000;
}

.header .nav-item > a.nav-link.menu-active.dropdown-active,
.header .nav-item a.nav-link.menu-active.dropdown-active {
    background-color: #EFEFEF !important;
    font-weight: 600 !important;
    color: #000;
}

.header .nav-item > a.nav-link.dropdown-with-active-route {
    background-color: #EFEFEF !important;
    font-weight: 600 !important;
    color: #000;
}

.header .nav-item ul li a.nav-link.submenu-active {
    font-weight: 600 !important;
    color: #000 !important;
}

@media (min-width: 701px) {
    .sidebar-toggle {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: none;
        align-self: center;
        width: 36px;
        height: 36px;
        margin: 0;
        padding: 0;
        border: 0;
        border-radius: 8px;
        background: transparent;
        cursor: pointer;
        transition:
            background-color .2s ease,
            width .32s cubic-bezier(.22, 1, .36, 1),
            height .32s cubic-bezier(.22, 1, .36, 1);
    }
    .sidebar-toggle:hover { background: #f3f3f6; }
    .sidebar-toggle.is-collapsed .ui-icon { transform: scaleX(-1); }
    .header.is-collapsed {
        width: 60px;
        background: #fafafc;
        overflow-y: auto !important;
        overflow-x: hidden !important;
        z-index: 40;
        nav {
            align-items: stretch;
            width: 100%;
            overflow: visible !important;
        }
        .brand-row {
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            gap: 10px;
            padding: 16px 8px 8px;
            min-height: 0;
        }
        .brand {
            flex: none;
            width: 28px;
            height: 36px;
            min-height: 36px;
            justify-content: center;
        }
        .brand-full {
            opacity: 0;
            transform: translateX(-12px) scale(0.9);
            filter: blur(2px);
            pointer-events: none;
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -24px;
            height: 48px;
            max-width: 182px;
            visibility: hidden;
            transition:
                opacity .22s ease,
                transform .28s cubic-bezier(.22, 1, .36, 1),
                filter .22s ease,
                visibility 0s linear .22s;
        }
        .brand-mark {
            opacity: 1;
            left: 50%;
            transform: translate(-50%, -50%) scale(1);
            pointer-events: auto;
            transition-delay: .06s;
        }
        .navbar-content {
            margin-top: 12px;
            width: 100%;
            align-items: center;
            overflow: visible !important;
        }
        ul.navbar-list {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            overflow: visible !important;
        }
        li.nav-item {
            display: flex;
            flex-wrap: nowrap;
            justify-content: flex-start;
            width: 100%;
            padding: 0 !important;
            margin: 0 0 8px;
            position: relative;
            overflow: visible;
        }
        li.nav-item.dropdown.is-flyout-open {
            z-index: 80;
        }
        li.nav-item > a.nav-link,
        li.nav-item > .nav-link {
            position: relative;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 44px !important;
            height: 44px !important;
            min-width: 44px;
            padding: 0 !important;
            margin: 0 0 0 8px !important;
            gap: 0 !important;
            font-size: 0 !important;
            line-height: 0 !important;
            border-radius: 8px;
            box-sizing: border-box;
            overflow: hidden;
            z-index: 1;
        }
        li.nav-item > a.nav-link > .ui-icon,
        li.nav-item > .nav-link > .ui-icon,
        li.nav-item > a.nav-link > span[class^="icon"],
        li.nav-item > a.nav-link > .fa {
            position: absolute;
            left: 50%;
            top: 50%;
            margin: 0 !important;
            transform: translate(-50%, -50%);
            text-align: center;
        }
        li.nav-item > a.nav-link.menu-active,
        li.nav-item > .nav-link.menu-active,
        li.nav-item > a.nav-link.dropdown-with-active-route,
        li.nav-item > a.nav-link.dropdown-active,
        li.nav-item.dropdown.is-flyout-open > a.nav-link {
            background: #f3f3f6 !important;
        }
        /* Flush to the sidebar edge — no gap, so hover does not drop.
           Selector must beat `.header ul li.nav-item.dropdown ul { position: relative }`. */
        ul li.nav-item.dropdown > ul.nav-submenu.is-collapsed-flyout {
            display: block !important;
            position: fixed !important;
            min-width: 228px;
            max-width: 280px;
            margin: 0 !important;
            padding: 8px !important;
            box-sizing: border-box;
            overflow-x: hidden;
            overflow-y: auto;
            background: #fff !important;
            border: 1px solid #e5e6eb;
            border-radius: 12px;
            box-shadow:
                0 4px 6px -1px rgba(31, 35, 55, 0.06),
                0 12px 28px -4px rgba(31, 35, 55, 0.14);
            z-index: 90 !important;
        }
        /* Flyout does not need the "connector corners" between submenu items. */
        ul li.nav-item.dropdown > ul.nav-submenu.is-collapsed-flyout > li:before {
            display: none !important;
            content: none !important;
        }
        ul li.nav-item.dropdown > ul.nav-submenu.is-collapsed-flyout > li {
            padding: 0 !important;
            margin: 0 0 2px !important;
            list-style: none;
            position: static !important;
        }
        ul li.nav-item.dropdown > ul.nav-submenu.is-collapsed-flyout > li > a.nav-link,
        ul li.nav-item.dropdown > ul.nav-submenu.is-collapsed-flyout > li > .nav-link {
            display: flex !important;
            align-items: center !important;
            justify-content: flex-start !important;
            width: 100% !important;
            min-width: 0;
            height: auto !important;
            min-height: 36px;
            margin: 0 !important;
            padding: 8px 10px !important;
            gap: 8px !important;
            font-size: 13px !important;
            line-height: 1.3 !important;
            font-weight: 500;
            color: #383c50;
            border-radius: 8px;
            box-sizing: border-box;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            position: static !important;
            left: auto !important;
            top: auto !important;
            transform: none !important;
        }
        ul li.nav-item.dropdown > ul.nav-submenu.is-collapsed-flyout > li > a.nav-link:hover,
        ul li.nav-item.dropdown > ul.nav-submenu.is-collapsed-flyout > li > a.nav-link.router-link-active,
        ul li.nav-item.dropdown > ul.nav-submenu.is-collapsed-flyout > li > a.nav-link.submenu-active {
            background: #f3f3f6 !important;
            color: #1f2337;
            font-weight: 600;
        }
        .notification {
            position: absolute;
            top: 8px;
            right: 8px;
            left: auto;
            width: 6px;
            height: 6px;
            margin: 0;
        }
        .insertion { display: none; }
        .sidebar-toggle {
            width: 44px;
            height: 44px;
            margin: 0;
        }
    }
    body.sidebar-collapsed .loggedAs {
        width: calc(~"100vw - 60px") !important;
    }
}

@media (max-width: 700px) {
    .header-mobile {
        display: flex;
    }
    .mobile-spacer { display: block; height: 56px; }
    .mobile-spacer.with-banner { height: 96px; }
    .sidebar-toggle { display: none; }
    .page-content .loggedAs {
        position: fixed;
        top: 56px;
        left: 0;
        width: 100% !important;
        margin: 0 !important;
    }
    .header {
        background: rgba(51, 51, 51, 0.8);
        left: 0%;
        width: 100%;
        margin-left: 0;
        top: 56px;
        height: calc(100% - 56px);
        transition: all 0.3s;
        opacity: 0;
        visibility: hidden;
        .brand-row {
            display: none;
        }
        .brand {
            display: none;
        }
        .close-mobile {
            display: block;
            width: 100%;
            text-align: right;
            border-bottom: 1px solid #e0e0e0;
            color: #747474;
            font-size: 12px;
            font-weight: normal;
            height: 50px;
            line-height: 50px;
            padding-right: 10px;
            svg.icon-close {
                cursor: pointer;
                float: right;
                font-size: 24px;
                margin-top: 14px;
                margin-left: 5px;
            }
        }
        nav {
            position: absolute;
            width: 85%;
            max-height: 100%;
            top: 0;
            left: 100%;
            padding: 0;
            background: #ffffff;
            transition: all 0.3s;
            .navbar-content {
                height: calc(~"100vh - 106px");
                overflow: scroll;
                margin-top: 0px;
                padding-bottom: 0px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
        }
        &.mobile-active {
            opacity: 1;
            visibility: visible;
            nav {
                left: 15%;
            }
        }
    }
}
</style>
